import { Injectable } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { B2BUnit } from '@spartacus/core';
import { FormService, UnitFormService } from '@spartacus/organization/administration/components';
import { CustomFormValidators } from '@spartacus/storefront';

@Injectable({
    providedIn: 'root',
})
export class UigUnitFormService extends UnitFormService {

    getForm(item?: B2BUnit): UntypedFormGroup {
        if (this.form && !!item) {
          this.patchData(item);
          return this.form;
        }
    
        if (!this.form) {
          this.build();
        }
    
        // while we should be able to reset with initial value, this doesn't always work
        // hence, we're patching afterwards.
        this.form.reset();
    
        this.form.enable();
        this.patchData(item);
        return this.form;
      }

    protected patchData(item?: B2BUnit) {
        super.patchData(item);
    }

    protected build() {
        const form = new UntypedFormGroup({});
        form.setControl(
            'uid',
            new UntypedFormControl('', [
                Validators.required,
                CustomFormValidators.noSpecialCharacters,
            ])
        );
        form.setControl('name', new UntypedFormControl(''));
        form.setControl('active', new UntypedFormControl(''));
        form.setControl('configEKPriceChangeDays', new UntypedFormControl(''));
        form.setControl('configProductCreationDays', new UntypedFormControl(''));

        this.form = form;
    }

}
